import {UserBasic} from "./User";
import {JsonProperty} from "../../common/utils/objectmapper/Mapper";
import {MomentConverters} from "./Converters";
import {Moment} from "moment";

export class ArchivPoznamka {
    id: number;

    poznamka: string;

    @JsonProperty({type:{clazz:UserBasic}})
    uzivatel: UserBasic;

    @JsonProperty({converters:MomentConverters})
    datIns: Moment;
}